import React, { useEffect } from 'react';
import {
  OwnProfileResponse,
  useGetAuthInspectQuery,
  useGetProfilesQuery,
} from '../store/backendApi';

interface PageLoaderProps {
  children: React.ReactElement;
  isSessionOptional?: boolean;
  setProfileDataData: React.Dispatch<React.SetStateAction<OwnProfileResponse | undefined | null>>;
}
const PageLoader = (props: PageLoaderProps) => {
  const { data: inspectData, error: inspectionLoadError } = useGetAuthInspectQuery();
  const { data: profileData, error: profileError } = useGetProfilesQuery(undefined, {
    skip: props.isSessionOptional && !inspectData,
  });

  useEffect(() => {
    // if login is not required and user is not logged in, dont fetch data.
    if (props.isSessionOptional && !inspectData) {
      props.setProfileDataData(null);
      return;
    }

    if (profileData) {
      props.setProfileDataData(profileData);
    }
  }, [inspectData, profileData]);
  return <>{props.children}</>;
};
export default PageLoader;
